import React, { Component } from 'react';
import KeyboardKeyMiami from './KeyboardKeyMiami';
import _ from 'lodash';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import FontAwesome from 'react-fontawesome'
import { connect } from 'react-redux';
import {checkData, shallowEqual, dp} from '../../../utils/shared.js'
import donorHelpers from '../../../utils/donorHelpers.js'
import dataHelpers from '../../../utils/dataHelpers.js'
import StoryMiami from './StoryMiami.js'
import InfoBlockMiami from './InfoBlockMiami.js';
import BackButtonMiami from './BackButtonMiami';
import miamiConstants from './MiamiConstants';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import DonorFullPage from '../Tampa//DonorFullPage';
import axios from 'axios'
import config from '../../../../config';

class UserInputMiami extends Component {

  constructor(props) {
    super(props);
    this.state = {
      text: "",
      module: this.props.module,
      virtual_keyboard_mode: 0,
      iScrollInitialized: false,
      scrollContainerHeight: "50vh",
      storyRefs: [],
      hideKeyboard: false,
      emailSent: false,
      showInvalidEmail: false,
      search: false
    }

    this._simple = null;
    this._simpleWithPictures = null;
    this._videos = null;
    this._donors = null;
    this._pills = null;
    this._resultsContainer = null;
    this._emailSentTimeout = null;
    this._clearInvalidEmailTimeout = null;
    this._pillsStorySetsByModules = [];
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.deleteText = this.deleteText.bind(this);
    this.normalMode = this.normalMode.bind(this);
    this.capitalMode = this.capitalMode.bind(this);
    this.submitText = this.submitText.bind(this);
    this._colorPallette = "golisano";
    this._backButton = null;

    this.getTimelineModule();

    //Refs
    this._storyPillsRefs = [];
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.search === false && this.state.search === true) {
      this.props.activateSwipeAnimation();
      this.checkSwipeAnimation();
    }
  }

  componentDidMount() {
    this.props.cancelSwipeAnimation();
  }

  componentWillMount(){
    checkData(this.props.module, this.props.screen.entry_point);
    this._emailSentTimeout = null;
    clearTimeout(this._emailSentTimeout);
  }

  shouldComponentUpdate(prevProps, prevState) {
    if (shallowEqual(this.state, prevState)) {
        return false;
    }
    return true;
  }

  componentWillUnmount() {
    clearTimeout(this._emailSentTimeout);
    clearTimeout(this._clearInvalidEmailTimeout);
  }

  checkSwipeAnimation = () => {
    const wrapperHeight = this._wrapperDiv.getBoundingClientRect().height;
    const contentHeight = this._innerDivRef.getBoundingClientRect().height;
  
    this.props.handleSwipeAnimation(wrapperHeight, contentHeight);
  }

  handleScrollStart = () => {
    this.props.cancelSwipeAnimation();
  }

  handleKeyPress(val) {
    if (typeof val === "function") {
      val();
    }
    else {
      let str = this.state.text + val;
      if (str.length < 40) {
        this.setState({
          text: str
        })
      }
    }

  }

  normalMode() {
    this.setState({
        virtual_keyboard_mode: 0
    })
  }

  capitalMode() {
    this.setState({
        virtual_keyboard_mode: 1
    })
  }

  deleteText() {
    if (this.state.text.length > 0) {
      let str = this.state.text.substring(0, this.state.text.length - 1);
      this.setState({
        text: str
      })
    }
  }

  validateEmail(email) {
    // eslint-disable-next-line
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  submitText() {
    this.setState({
      iScrollInitialized: false
    })

    const type = _.get(this.props.module, 'contents.custom_fields.folder_type.val.value', null);
    if (type === "be_the_change") {
      if (!this.validateEmail(this.state.text)){
        this.setState({
          showInvalidEmail: true
        })
        clearTimeout(this._clearInvalidEmailTimeout);
        this._clearInvalidEmailTimeout = null;
        this._clearInvalidEmailTimeout = setTimeout(() => {
          this.setState({
            showInvalidEmail: false
          })
        }, 2000)
        return;
      }
      axios.get(config.WEB_SERVER + "/display/submituserinput", {
        params: {
          display: this.props.content.id,
          text: this.state.text,
          authkey: config.AUTHKEY
        }
      })
      .then((response) => {
        this.setState({
          hideKeyboard: true
        });

        this._emailSentTimeout = null;
        clearTimeout(this._emailSentTimeout);
        this._emailSentTimeout = setTimeout(() => {
          this.setState({
            emailSent: true
          })
        }, 500)
      })
      .catch((error) => {
        this.setState({
          emailSent: false,
          hideKeyboard: false
        });
      });
    } else if (type === "search") {
      this._pillsStorySetsByModules = [];
      this._storyPillsRefs = [];
      this._storyPillsRefs.length = 0;
  
      const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
      const donorSearchResults = donorHelpers.searchInFolderDonorLists(this.props.content.story_categories, this.props.donors, this.state.text, Number(rootFolderId));
      const storiesResult = dataHelpers.searchStory(this.props.content, this.state.text, []);
      const orderedStoriesResult = _.orderBy(storiesResult, ['sorting_name', 'asc']);
      const menu = this.props.content.story_categories.find(folder => {
        const folderType = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
        return folder.parent_category === Number(rootFolderId) && folderType === "menu";
      });
      const menuItems = this.props.content.story_categories.filter(folder => folder.parent_category === menu.id);
      let results = {};
      for (let j = 0; j < menuItems.length; j++) {
        const type = _.get(menuItems[j], 'contents.custom_fields.folder_type.val.value', null);
        if (type === "donor_stories_pill") {
          if (!results[type]) {
            results[type] = [];
          }
          const folderModules = this.props.content.folder_modules.filter(fm => fm.folder === menuItems[j].id).map(fm => fm.module_id);
          const foundStories = orderedStoriesResult.filter(story => folderModules.indexOf(story.id) > -1);
          if (foundStories.length) {
            results[type].push({
              folder: menuItems[j],
              stories: foundStories
            });
          }
        }
      }

      let donorResults = []
      for (let i = 0; i < donorSearchResults.foundFolders.length; i++) {
        const folder = this.props.content.story_categories.find(folder => folder.id === donorSearchResults.foundFolders[i]);
        const parent = this.props.content.story_categories.find(fParent => fParent.id === folder.parent_category);
        const donors = donorSearchResults.foundDonors.filter(donor => donor.folder_module.folder === folder.id);
        const index = donorResults.findIndex(r => r.id === parent.id);
        const hideTitle = _.get(folder, 'contents.custom_fields.hide_title.val', false);
        if (index > -1) {
          donorResults[index].group.push({ name: folder.name, rank: folder.rank, donors: donors, hideTitle: hideTitle });
        } else {
          donorResults.push({
            id: parent.id,
            name: parent.name,
            rank: parent.rank,
            hideTitle: hideTitle,
            group: [{
              name: folder.name,
              rank: folder.rank,
              donors: donors
            }]
          });
        }
      }

      this.renderResults(results);
      this.renderDonors(donorResults);

      let countResults = donorResults.length;
      for (let storyType in results) {
        if (results[storyType] && results[storyType].length > 0) {
          countResults++;
        }
      }
  
      this.setState({
        search: true,
        pills: this._pills,
        simpleWithPictures: this._simpleWithPictures,
        simple: this._simple,
        videos: this._videos,
        donors: this._donors,
        searchHasResults: countResults > 0 ? true : false,
      });
    }
  }

  getBackgroundImage = () => {
    const defaultImg = {path:'/img/miami/general/', file_name:'default_single_screen.jpg'}
    if (this.props.screensNumber === 2) {
      defaultImg.file_name = 'default_double_screen.jpg';
    }
    return dp(this.props.screen, _.get(this.props.module, 'contents.images[2]'), null);
  }

  getIconImage = () => {
    return dp(this.props.screen, _.get(this.props.module, 'contents.images[1]'), null);
  }

  getTimelineModule = () => {
		this._menuModules = _.filter(this.props.content.dm_active, { module_contents: { in_navigation: true } });
		this._menuModules.forEach((module, row) => {
			if (module.display_module_type === "Timeline") {
        this._timelineModule = module;
			}
		});
	}

  removeInputText = () => {
    this.props.cancelSwipeAnimation();
    this.setState({
      text: "",
      search: false
    });
  }

  initializeIScroll = () => {
    if (this.state.iScrollInitialized === false) {
      for (let i = 0; i < this._storyPillsRefs.length; i++) {
        if (this._storyPillsRefs[i] && this._storyPillsRefs[i].el) {
          this._storyPillsRefs[i].el.addEventListener("tap", () => this.handleTap(this._storyPillsRefs[i].moduleIndex, this._storyPillsRefs[i].storySetIndex, this._storyPillsRefs[i].pillIndex));
        }
      }

      this.setState({
        iScrollInitialized: true
      })
    }
  }

  handleTap = (moduleIndex, storySetIndex, pillIndex) => {
    let storyId = this._pillsStorySetsByModules[moduleIndex][storySetIndex][pillIndex].id;
    let propsStoryIndex = _.findIndex(this.props.content.stories, {id: storyId});

    this.setState({
      storyIndex: propsStoryIndex,
      showModal: true
    });    
  }

  handleBack = () => {
    this.setState({
      showModal: false
    })
  }

  beTheChange = () => {
		return (
			<div style={{ margin:"auto", width: (this.props.screen.screenWidth / this.props.screensNumber) * .80 , marginTop: '7vw', marginBottom: '5vw', display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', justifyContent: 'flex-start', alignItems: 'stretch', alignContent: 'stretch' }}>
				<div style={{ fontSize: '3.5vw', lineHeight: "107%", textAlign: "left", fontFamily: "opensans-semibold", color: '#ffffff', width: '150vw' }}>
					Explore Our Story
				<br />
					<span style={{ fontSize: '2.2vw', textAlign: "left", fontFamily: "opensans-regular", color: '#ffffff' }}>
						Learn how our facility came to be through generous donations
					</span>
				</div>

				<div style={{ textAlign: 'right', width: '100%' }}>
					<img onClick={() => this.redirect()} alt="Story" src={"/img/miami/general/learnmore_grad_button.png"} style={{ width: '23vw' }} />
				</div>
			</div>
		)
  }
  
	redirect = () => {
    if (this._timelineModule !== null && this._timelineModule !== undefined) {
			this.props.navRoute('/miami/timeline', this._timelineModule);
		}
	}

  renderPills = (results) => {
    let renderedPills = (
      results.map((module, moduleIndex) => {
        // Organizing stories in sets of 3
        let storySets = [];
        let setCount = 0;
        if (module.stories.length > 0) {
          for (let i = 0; i < module.stories.length; i++) {
            if (!storySets[setCount]) {
              storySets[setCount] = [];
            }
            storySets[setCount].push(module.stories[i]);
            if ((i + 1) % 3 === 0 && i !== 0) {
              setCount++
            }
            if (i === 2) {
              storySets[setCount++] = [] //empty entry for spacer row
            }
          }

          this._pillsStorySetsByModules[moduleIndex] = storySets;

          let renderedStories = (storySets.map((row, storySetIndex) => {
            return (
              <div key={"module" + moduleIndex + "storySet" + storySetIndex} style={{ marginBottom: this.props.screen.r9_16.p10 * .17, display: 'flex', alignItems: 'center', justifyContent:"center" }}>
                {this.renderPillsRow(row, moduleIndex, storySetIndex)}
              </div>
            )
          }));
  
          let header = (
            <div style={{ marginLeft:"auto", marginRight:"auto", width:"95%" }}>
              <span style={{ fontWeight:"bold", fontSize:"1.35vh" }}>{module.folder.name}</span>
              <hr style={{ backgroundColor:"white" }}/>
            </div>
          );

          let pills = (
            <div key={"module" + moduleIndex}>
              {header}
              {renderedStories}
            </div>
          );
          return pills;
        } else {
          return (<div key={moduleIndex}/>);
        }
      })
    );

    return renderedPills;
  }

  renderPillsRow = (row, moduleIndex, storySetIndex) => {
    let dummyStories = [];

    if (row.length === 0) {
      return null;
    }
    let storySet = (
      row.map((innerrow, pillIndex) => {
        this._renderPillCount = this._renderPillCount + 1;
        let myCount = this._renderPillCount;
        return (
          <div key={"pill" + pillIndex} ref={(el) => this._storyPillsRefs[myCount] = {moduleIndex: moduleIndex, pillIndex:pillIndex, storySetIndex:storySetIndex, el: el}} style={{ display: 'inline-block' }}>
            {this.renderPillsStory(innerrow, pillIndex, moduleIndex, storySetIndex)}
          </div>
        )
      })
    );
  
    if (row.length < 3) {
      let itemsLeft = 3 - row.length;
      const unit = this.props.screen.r9_16.p10 / this.props.screensNumber;
      for (let i = 0; i < itemsLeft; i++) {
        let marginRight = i === (itemsLeft - 1) ? 0 : unit * .175;
        dummyStories.push(<div key={row.length - i} style={{ display:"inline-block", width:"15.416666667vh", marginRight:marginRight }}/>);
      }
    }

    return (
      <div>
        {storySet}
        {dummyStories}
      </div>
    );
  }

  renderPillsStory = (row, pillIndex, moduleIndex, storySetIndex) => {
    const unit = this.props.screen.r9_16.p10 / this.props.screensNumber;
    let marginRight = pillIndex === 2 ? 0 : unit * .175;
    let mult = .8    
    return (
      <div style={{ marginRight: marginRight, display: 'inline-block' }}>
        <InfoBlockMiami
          arrowIcon={this._backButton}
          imgsrc={dp(this.props.screen, _.get(row, 'contents.images[0]', null), {path: '/img/ui/', file_name: 'image_default.png'})}
          imageHeight={unit * 2 * mult}
          infoHeight={"4.6875vh"}
          width={"15.416666667vh"}
          unit={unit * mult}
          text={row.name}
          infoColor={"black"}
          infoBackgroundColor={'white'}
          fontFamily={'opensans-regular'}
          fontSize={unit * 0.15}
        />
      </div>
    )
  }

  renderSimple = (results) => {
    let renderedSimple = results.map((module, i) => {
      if (module.stories.length > 0) {
        let header = (
          <div>
            <span style={{ fontWeight:"bold", fontSize:"1.35vh" }}>{module.display_module.name}</span>
            <hr style={{ backgroundColor:"white" }}/>
          </div>
        );

        let renderedStories = (
          module.stories.map((row, j) => {
            const unit = this.props.screen.r9_16.p10
        
            let boxStyle = {
              paddingLeft: '3.375vh',
              paddingRight: '3.375vh',
              paddingTop: '1.96875vh',
              paddingBottom: '1.96875vh',
              width: "100%"
            }
    
            return (
              <div key={j} style={{ display:"table", lineHeight: '140%', marginTop: '1.5vh', backgroundColor: 'white', fontSize: '1.96875vh', fontFamily: "opensans-bold", color: '#404040', borderTopLeftRadius: unit * 0.08, borderTopRightRadius: unit * 0.08, borderBottomLeftRadius: unit * 0.08, borderBottomRightRadius: unit * 0.08 }}>
                <div style={{ ...boxStyle, display:"table-cell" }}>
                  <div style={{ marginTop: '1.125vh', position: 'relative', fontSize:"2.1875vh" }}>
                    {row.name}
                  </div>
                  <hr style={{ backgroundImage:"url(/img/miami/general/rainbowuistrip_dark.png)", backgroundSize:"cover", backgroundPosition:"center", height:"0.098958333vh" }}/>
                  <div style={{ fontSize: '.9vh', lineHeight: '140%', fontFamily: "opensans" }}>
                    {row.contents.story}
                  </div>
                </div>
                <br />
              </div>
            )
          })
        );

        let pills = (
          <div key={i}>
            {header}
            {renderedStories}
          </div>
        );

        return pills;
      }

      return null;
    });

    return renderedSimple;
  }

  renderSimpleWithPictures = () => {
    return null;
  }

  renderVideos = () => {
    return null;
  }

  renderResults = (results) => {
    this._renderPillCount = -1;
    this._pills = [];
    this._simple = [];
    this._simpleWithPictures = [];
    this._videos = [];

    for (let property in results) {

      switch(property) {
        case "donor_stories_pill":
          this._pills.push(this.renderPills(results[property]));
        break;
        case "donor_stories_text_block":
          this._simple.push(this.renderSimple(results[property]));
        break;
        case "donor_stories_text_block_picture":
          this._simpleWithPictures.push(this.renderSimpleWithPictures(results[property]));
        break;
        case "videos":
          this._videos.push(this.renderVideos(results[property]));
        break;
        default:
          console.log("Not Found");
        break;
      }
    }
  }

  renderDonors = (donorGroups) => {
    let columns = 2;
    let rows = 6;
    let fontClass = 'gfont_roboto';

    let categoryWrapStyle = {
      boxSizing: 'border-box',
      width: this.props.screen.screenWidth * 0.78838174273858921162,
      color: "black",
      background: "white",
      // height: this.props.screen.r9_16.height * .5,
      paddingBottom: this.props.screen.screenHeight * 0.01875,
      paddingTop: this.props.screen.screenHeight * 0.02893518518518518519,
      borderRadius: 10,
      paddingLeft: this.props.screen.screenWidth * 0.074074074,
      paddingRight: this.props.screen.screenWidth * 0.074074074,
      marginBottom: this.props.screen.screenHeight * 0.03125
    }

    let renderedDonors = (
      donorGroups.map((donorsByModule, k) => {
        let header = null;
        let donorFullPageWidth = this.props.screen.screenWidth * 0.78838174273858921162 - (this.props.screen.screenWidth * 0.074074074 * 2);
        if (donorsByModule.group.length > 0) {
          header = (
            <div style={{ marginLeft:"auto", marginRight:"auto", width:"95%" }}>
              <span style={{ fontWeight:"bold", fontSize:"1.35vh", width:"95%" }}>{donorsByModule.name}</span>
              <hr style={{ backgroundColor:"white" }}/>
            </div>
          );
        }

        let donorGroups = donorsByModule.group.map((group, i) => {
          // let height = (Math.ceil(group.donors.length / columns) * this.props.screen.screenHeight * 0.115 / rows) + (this.props.screen.screenHeight * 0.021875) + categoryWrapStyle.paddingTop * 2 + categoryWrapStyle.paddingBottom * 2;
          // let donorFullPageWidth = this.props.screen.screenWidth * 0.78838174273858921162 - (this.props.screen.screenWidth * 0.074074074 * 2);
          return (
            <div key={i} style={{ display:"flex", alignItems:"center", justifyContent: "center" }}>
              <div className="opensans-regular" style={{ ...categoryWrapStyle }} >
                {
                  donorsByModule.hideTitle === false ?
                  <div style={{ paddingLeft: this.props.screen.screenHeight * .01562, fontSize: this.props.screen.screenHeight * 0.021875 }}>
                    <h1 style={{ fontSize: this.props.screen.screenHeight * 0.021875 }}>{group.name}</h1>
                  </div>
                  : null
                }
                <div>
                  <DonorFullPage
                    height={this.props.screen.screenHeight * 0.115}
                    width={donorFullPageWidth}
                    columns={columns}
                    rows={rows}
                    fontClass={fontClass}
                    donorData={group.donors}
                    screen={this.props.screen}
                    sort="row"
                    overrideFontSize={0}
                    overridePadding={this.props.screen.screenHeight * .01562}
                    overrideMarginRight={0}
                    custom1x2={'<span />'}>
                  </DonorFullPage>
                </div>
              </div>
            </div>
          )
        });

        return (
          <div key={k}>
            {header}
            {donorGroups}
          </div>
        );
      })
    );

    this._donors = renderedDonors;
  }

  renderBackButton = () => {
    return (
      <BackButtonMiami
        colorPallette={this._colorPallette}
        backButton={this._backButton}
        unit={this.props.screen.r9_16.p10 / this.props.screensNumber}
        width="3.375vh"
        height={miamiConstants.backButtonHeight}
        top="56.46875vh"
        border="0.84375vh"
        clickAction={this.handleBack}
        text={'back'}
        mode={this._mode}>
      </BackButtonMiami>
    );
  }

  render() {
    const backgroundImage = this.getBackgroundImage();
    const iconImage = this.getIconImage();
    const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
    const rootFolderId = _.get(this.props.content, 'settings.selected_root_folder', null);
    const rootFolder = this.props.content.story_categories.find(folder => folder.id === Number(rootFolderId));
    const menu = this.props.content.story_categories.find(folder => {
      const type = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      return folder.parent_category === Number(rootFolderId) && type === "menu";
    });
    this._backButton = dp(this.props.screen, _.get(menu, 'contents.images[0]', null), null);
    this._colorPallette = _.get(rootFolder, 'contents.custom_fields.color_pallette.val.value', 'golisano');
    const colorPallette = this._colorPallette;
    let fontColor = "#95268E";
    let className = "kspn";
    if (this._colorPallette === "adaptive") {
      className = "kspn-primary";
      fontColor = "#000";
    }
    
    let mod = .6;

    let keystd = {
      width: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.9 * mod,
      height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
      margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
      borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.15 * mod,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
      fontSize:".98vh"
    }

    let keyspace = {
      width: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.6 * mod,
      height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
      margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
      borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.15 * mod,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
      fontSize:".98vh"
    }

    let keycom = {
      width: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.6 * mod,
      height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
      margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
      borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.15 * mod,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
      fontSize:".98vh"
    }

    let keysubmit = {
      width: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.6 * mod,
      height: this.props.screen.r9_16.p10 / this.props.screensNumber * 1.05 * mod,
      margin: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.1 * mod,
      borderRadius: this.props.screen.r9_16.p10 / this.props.screensNumber * 0.5 * mod,
      display: 'inline-block',
      backgroundColor: 'white',
      textAlign: 'center',
    }

    const unit = this.props.screen.r9_16.p10   
    const textAlign = this.state.text.length > 0 ? "center":"left"; 

    let boxStyle = {
      paddingLeft: '3.375vh',
      paddingRight: '3.375vh',
      paddingTop: '1.96875vh',
      paddingBottom: '1.96875vh',
      width: "100%"
    }
    // const horizontalRadius = this.props.screen.screenHeight * .00520833333333333333;
    // const verticalRadius = this.props.screen.screenHeight * .00651041666666666667;
    let margins = {
      descriptionTop: this.props.screen.screenHeight * .00651041666666666667
    }

    //move just the keyboard input mode into redux, so that this state doesn't need to be passed from parent to child, or alternatively use a parent->child or child->parent watch.

    const type = _.get(this.props.module, 'contents.custom_fields.folder_type.val.value', null);
    if (!this.props.module){
      return <span />
    }

    return (
      <div>


        {/* Modal */}
        <CSSTransitionGroup
          component='div'
          className="containerFade"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.showModal} style={{ zIndex:99999 }}>
            {
              this.state.showModal ?
                <StoryMiami 
                  screen={this.props.screen} 
                  screensNumber={this.props.screensNumber} 
                  navRoute={this.props.navRoute} 
                  stories={this.props.content.stories} 
                  background={this.getBackgroundImage()} 
                  backgroundEnabled={true} 
                  mode="image" 
                  clickAction={this.handleBack} 
                  contentIndex={this.state.storyIndex} />
                :
                null}
            {this.state.showModal ? this.renderBackButton() : null}
          </div>
        </CSSTransitionGroup>

        {/* Screen */}
        <div style={{ width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundImage: "url(" + backgroundImage + ")", backgroundSize: backgroundSize }} >
          <div style={{ position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber }} >
            {/* Header */}
            <div style={{ display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' }}>
              <div style={{ height: "4vh" }}>
              </div>
              <img alt="icon" src={iconImage} style={{ width: '16vh' }} />
            </div>
            <div style={{ fontFamily: 'opensans-extrabold', textAlign: "center", fontSize: '3.6vh' }}>
              {this.props.module.name.toUpperCase()}
            </div>
            <div style={{ fontFamily: 'opensans-regular', fontSize: '1.6851vh', textAlign: "center" }}>
              {this.props.module.description}
            </div>
            {/* <div className="topgradblackP25" style={{ position: "absolute", width: '100%', height: unit * .25, top: "32.916666667vh", left: 0 }} /> */}
            <div className="topgradblackP25" style={{ position:"absolute", width: '100%', height: unit * .25, top: "26.979166667vh", left: 0 }} />


        {/* Invalid Email Modal */}
        <CSSTransitionGroup
          component='div'
          className="containerFade"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.showInvalidEmail} style={{ zIndex:99999 }}>
            {
              this.state.showInvalidEmail ?
                    <div style={{ height: '100vh', width: '56vh', display: "flex", justifyContent: "center" }}>
                    
                      <div style={{ marginTop: '3vh', display: 'inline-block', width: '35vh', height: "3vh", border: "0.3125vh", borderStyle: "solid", opacity: .9, borderColor: "#FFFFFF", backgroundColor: '#FFFFFF', borderRadius: this.props.screen.r9_16.p10 * 0.8 }}>
                        <span style={{ height: "3vh", display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: "1.6vh", color: "red" }}>
                          Please enter a valid email address.
                        </span>
                      </div>
                    </div>
                :
                null}
          </div>
        </CSSTransitionGroup>

            {/* Keyboard */}
            <CSSTransitionGroup
              component='div'
              transitionName='example'
              transitionEnterTimeout={0}
              transitionLeaveTimeout={0}>
              <div key={this.state.hideKeyboard}>
                {
                  !this.state.hideKeyboard ?
                  <div>
                    <div style={{ height: '8.3vh' }} />
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div style={{ display: 'inline-block', width: '45vh', height: "5.83vh", border: "0.3125vh", borderStyle: "solid", borderColor: "#FFFFFF", borderRadius: this.props.screen.r9_16.p10 * 0.8 }}>
                        <span style={{ height: "6.16667vh", display: 'flex', alignItems: 'center', justifyContent: textAlign, fontSize: "1.6vh", color: "white", float: "left", width: "90%" }}>
                          {
                            this.state.text.length > 0 ?
                              <div>&nbsp;{this.state.text}&nbsp;</div>
                              : <div style={{ fontSize: "2.5vh", fontWeight: "bold" }}>
                                {
                                  type === "be_the_change" ?
                                    <div style={{ marginLeft: "2.34vh" }}>Enter your Email Address</div>
                                    :
                                    <div style={{ marginLeft: "6vh" }}>
                                      Enter a donor name
                                </div>
                                }
                              </div>
                          }
                          {
                            type === "search" ?
                              <FontAwesome style={{ fontSize: "2.5vh", position: "absolute", left: "7.8125vh" }} name='search' />
                              : null
                          }
                        </span>
                        <span onClick={this.removeInputText} style={{ height: "4.166666667vh", display: 'flex', fontSize: "2vh", color: "white", float: "right", paddingTop: "1.9375vh", paddingRight: "2vh", fontWeight: "bold" }}>
                        <FontAwesome name='times' />
                      </span>
                      </div>
                    </div>
                    <div style={{ color: 'black', width: '85%', height: "30vh", display: "block", marginLeft: "auto", marginRight: "auto", }}>
                      {/* <div style={{ height: '5vh' }} /> */}
                      <div className="helem" style={{ position: "relative", paddingTop: "2vh" }}>
                        <div>
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[1, 1, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[1, 1, null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[2, 2, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[2, 2, null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[3, 3, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[3, 3, null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[4, 4, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[4, 4, null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[5, 5, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[5, 5, null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[6, 6, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[6, 6, null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[7, 7, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[7, 7, null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[8, 8, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[8, 8, null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[9, 9, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[9, 9, null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[0, 0, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={[0, 0, null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[this.deleteText, this.deleteText, this.deleteText]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['DELETE', 'DELETE', 'DELETE']} />
                          <br />

                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['q', 'Q', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['q', 'Q', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['w', 'W', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['w', 'W', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['e', 'E', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['e', 'E', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['r', 'R', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['r', 'R', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['t', 'T', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['t', 'T', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['y', 'Y', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['y', 'Y', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['u', 'U', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['u', 'U', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['i', 'I', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['i', 'I', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['o', 'O', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['o', 'O', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['p', 'P', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['p', 'P', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['@', null, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['@', '@', null]} />
                          <br />

                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['a', 'A', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['a', 'A', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['s', 'S', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['s', 'S', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['d', 'D', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['d', 'D', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['f', 'F', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['f', 'F', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['g', 'G', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['g', 'G', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['h', 'H', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['h', 'H', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['j', 'J', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['j', 'J', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['k', 'K', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['k', 'K', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['l', 'L', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['l', 'L', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['_', '_', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['_', '_', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['&', '&', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['&', '&', null]} />
                          <br />

                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['z', 'Z', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['z', 'Z', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['x', 'X', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['x', 'X', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['c', 'C', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['c', 'C', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['v', 'V', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['v', 'V', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['b', 'B', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['b', 'B', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['n', 'N', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['n', 'N', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['m', 'M', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['m', 'M', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['.', '.', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['.', '.', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['-', '-', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['-', '-', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['*', '*', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['*', '*', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['?', '?', null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['?', '?', null]} />

                          <br />
                          <div style={keystd}><span className={className}>=/#</span></div>
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[this.capitalMode, this.normalMode, null]} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keystd} contents={['UPCASE', 'DOWNCASE', null]} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={[' ', ' ', ' ']} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keyspace} contents={['Space', 'Space', 'Space']} />
                          <KeyboardKeyMiami colorPallette={colorPallette} keyval={['.com', '.com', '.com']} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.handleKeyPress} mainstyle={keycom} contents={['.com', '.com', '.com']} />
                          <KeyboardKeyMiami colorPallette={colorPallette} searchStr={this.searchStr} keyval={['Submit', 'Submit', 'Submit']} virtual_keyboard_mode={this.state.virtual_keyboard_mode} handleKeyPress={this.submitText} mainstyle={keysubmit} contents={['Submit', 'Submit', 'Submit']} />
                        </div>
                      </div>
                    </div>
                    <CSSTransitionGroup
                      component='div'
                      className="containerFade"
                      style={{ minHeight: '100%' }}
                      transitionName='example'
                      transitionEnterTimeout={0}
                      transitionLeaveTimeout={0}>
                      <div ref={el => this._wrapperDiv = el} key={this.state.search} style={{ width: "90%", marginLeft: "auto", marginRight: "auto", position: "relative", height: "39.2vh", touchAction:"none" }}>
                        {
                          this.state.search ?
                            <ReactIScroll ref={el => this.iScroller = el} iScroll={iScroll}
                            onScrollStart={this.handleScrollStart}
                            options={{
                                mouseWheel: true,
                                scrollbars: false,
                                scrollX: false,
                                scrollY: true,
                                probeType: 2,
                                bounce: false,
                                momentum: true,
                                deceleration: 0.005,
                                useTransition: true,
                                disableTouch: false,
                                disablePointer: false,
                                disableMouse: false,
                                tap: true
                              }}
                              onRefresh={this.initializeIScroll}
                            >
                              <div ref={el => this._innerDivRef = el}>
                                {
                                  this.state.searchHasResults ?
                                  <div>
                                    {this.state.donors}
                                    {this.state.pills}
                                    {this.state.simple}
                                  </div>
                                  :
                                  <div key={this.state.searchHasResults} style={{ height: "6vh", backgroundColor: "white", position: "relative", top: "5vh", width: "85%", margin: "0 auto", borderRadius: this.props.screen.screenWidth * .03472222222222222222, paddingTop: "3vh", paddingBottom: "3vh", display: "table",  verticalAlign: "middle" }}>
                                    <div style={{ fontFamily: "open-sans-regular", fontSize: this.props.screen.screenHeight * .02199074074074074074, textAlign: "center", width: "100%", color: fontColor, display:"table-row" }}>
                                      Sorry, no results for "{this.state.text}".
                                    </div>
                                    <div className="opensans-regular" style={{ display:"table-row", fontFamily: "open-sans-regular", fontSize: this.props.screen.screenHeight * .02199074074074074074, maxHeight: "6vh", overflow: "hidden", textAlign: "center", width: "100%", marginTop: margins.descriptionTop, WebkitLineClamp: 3, WebkitBoxOrient: "vertical", color: fontColor }}>
                                      Click the "X" in the text box to start a new search.
                                    </div>
                                  </div>
                                }
                                <div style={{ height: "9vh" }} />
                              </div>
                            </ReactIScroll>
                            : null
                        }
                      </div>
                    </CSSTransitionGroup>
                  </div>
                  :null
                }
              </div>
            </CSSTransitionGroup>
          
            {/* Email Sent Thank you */}
            <CSSTransitionGroup
              component='div'
              transitionName='example'
              transitionEnterTimeout={0}
              transitionLeaveTimeout={0}>
              {
                this.state.emailSent ?
                <div key={this.state.emailSent}>
                  <div style={{ height: "11vh" }} />
                  <div style={{ margin: "auto", width: (this.props.screen.screenWidth / this.props.screensNumber) * 0.85, display: "table", lineHeight: '140%', marginTop: '1.5vh', backgroundColor: 'white', fontSize: '1.96875vh', fontFamily: "opensans-bold", color: '#404040', borderTopLeftRadius: unit * 0.08, borderTopRightRadius: unit * 0.08, borderBottomLeftRadius: unit * 0.08, borderBottomRightRadius: unit * 0.08 }}>
                    <div style={{ ...boxStyle, display: "table-cell" }}>
                      <div style={{ marginTop: '1.125vh', position: 'relative', fontSize: "2.1875vh" }}>
                        Thank you
                      </div>
                      <div style={{ fontSize: '.9vh', lineHeight: '140%', fontFamily: "opensans" }}>
                        We have received your email and will be in touch. Thank you for your interest
                      </div>
                    </div>
                    <div style={{ height: "2vh" }} />
                    <br />
                  </div>
                  {this.beTheChange()}
                </div>
                :null
              }
            </CSSTransitionGroup>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    content: state.content,
    donors: state.donors,
  };
};

export default connect(mapStateToProps, null)(UserInputMiami);


// WEBPACK FOOTER //
// ./src/Components/Theme/Miami/UserInputMiami.js